// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCJOwfsKVvc1x3fA78SAuTzcboNOZ2rVEM",
  authDomain: "dashboard-5b1d8.firebaseapp.com",
  projectId: "dashboard-5b1d8",
  storageBucket: "dashboard-5b1d8.appspot.com",
  messagingSenderId: "748253334756",
  appId: "1:748253334756:web:d11089072e6f4f3956b0f1",
  measurementId: "G-ZE19RL5RC7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

